import {EVENT_CLOSE_MODAL} from '@common/utils/event.js';

export default {
    props: {
        id: {
            type: Number,
            required: true,
        },
    },

    methods: {
        close() {
            history.go(-1);
        },

        onPopstate(event) {
            const modalIds = event.state?.modalId || [];

            if (!modalIds.find(id => id === this.id)) {
                this.$eventBus.$emit(EVENT_CLOSE_MODAL, {id: this.id});
            }
        },
    },

    created() {
        window.addEventListener('popstate', this.onPopstate);
    },

    beforeDestroy() {
        window.removeEventListener('popstate', this.onPopstate);
    },
}
